"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureExpGoals = void 0;
const createApi_1 = require("../../../helpers/createApi");
const schemas_1 = require("./schemas");
const list = (caller) => async ({ accountId, campaignId, params }) => caller(`/accounts/${accountId}/campaigns/${campaignId}/goals`).get(params).then(schemas_1.GoalCollectionSchema.parse);
const get = (caller) => async ({ accountId, campaignId, goalId }) => caller(`/accounts/${accountId}/campaigns/${campaignId}/goals/${goalId}`).get().then(schemas_1.GoalSchema.parse);
const updateGoal = (caller) => async (params) => {
    const { accountId, campaignId, goalId, ...payload } = schemas_1.UpdateGoalParamsSchema.parse(params);
    const url = `/accounts/${accountId}/campaigns/${campaignId}/goals/${goalId}`;
    return caller(url).patch(payload);
};
const deleteGoal = (caller) => async ({ accountId, campaignId, goalId }) => {
    const url = `/accounts/${accountId}/campaigns/${campaignId}/goals/${goalId}`;
    return caller(url).delete();
};
const createGoal = (caller) => async (params) => {
    const { accountId, campaignId, ...payload } = schemas_1.CreateGoalParamsSchema.parse(params);
    const url = `/accounts/${accountId}/campaigns/${campaignId}/goals`;
    return caller(url).post(payload);
};
const getGoalTemplates = (caller) => async ({ accountId, accountEnvId, params }) => caller(`/accounts/${accountId}/account_environments/${accountEnvId}/goal-templates`)
    .get(params)
    .then(schemas_1.GoalTemplateCollectionSchema.parse);
const createGoalTemplate = (caller) => async (params) => {
    const { accountId, accountEnvId, ...payload } = schemas_1.CreateGoalTemplateParamsSchema.parse(params);
    const url = `/accounts/${accountId}/account_environments/${accountEnvId}/goal-templates`;
    return caller(url).post(payload);
};
const updateGoalTemplate = (caller) => async (params) => {
    const { accountId, accountEnvId, goalTemplateId, ...payload } = schemas_1.UpdateGoalTemplateParamsSchema.parse(params);
    const url = `/accounts/${accountId}/account_environments/${accountEnvId}/goal-templates/${goalTemplateId}`;
    return caller(url).patch(payload);
};
const getGoalTemplate = (caller) => async ({ accountId, goalTemplateId, accountEnvId }) => {
    return caller(`/accounts/${accountId}/account_environments/${accountEnvId}/goal-templates/${goalTemplateId}`)
        .get()
        .then(schemas_1.GetDetailedGoalTemplateSchema.parse);
};
const deleteGoalTemplate = (caller) => async (params) => {
    const { accountId, accountEnvId, goalTemplateId } = schemas_1.DeleteGoalTemplateParamsSchema.parse(params);
    return caller(`/accounts/${accountId}/account_environments/${accountEnvId}/goal-templates/${goalTemplateId}`).delete();
};
exports.featureExpGoals = (0, createApi_1.createAPIFactory)({
    list,
    get,
    createGoal,
    deleteGoal,
    getGoalTemplates,
    createGoalTemplate,
    updateGoalTemplate,
    getGoalTemplate,
    updateGoal,
    deleteGoalTemplate,
});
//# sourceMappingURL=api.js.map